import { Injectable, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class NotificationsService {
    private _notificationsReceived = new Subject<number>();
    $notificationsReceived = this._notificationsReceived.asObservable();

    private _unreadNotificationsCount = 0;

    set unreadNotificationsCount(value) {
        this._unreadNotificationsCount = value;
        this._notificationsReceived.next(value);
    }

    constructor() { }
}
